class RecordingsDB {
  constructor() {
    this.recordings = [];
    this.db = null;
    const request = indexedDB.open('recordingsDB', 1);
    request.onerror = (event) => {
      console.error('Database error: ', event.target.errorCode);
    };
    request.onupgradeneeded = (event) => {
      this.db = event.target.result;
      if (!this.db.objectStoreNames.contains('recordings')) {
        this.db.createObjectStore('recordings', { autoIncrement: true });
      }
      if (!this.db.objectStoreNames.contains('settings')) {
        this.db.createObjectStore('settings', { autoIncrement: false });
      }
    };
    request.onsuccess = (event) => {
      this.db = event.target.result;
    };
  }
  checkBlobSupport() {
    let testDB;
    return new Promise((resolve, reject) => {
      var openRequest = indexedDB.open('blob-support-check', 1);

      openRequest.onupgradeneeded = function (e) {
        testDB = e.target.result;
        testDB.createObjectStore('blobs');
      };

      openRequest.onsuccess = function (e) {
        testDB = e.target.result;
        try {
          var transaction = testDB.transaction('blobs', 'readwrite');
          var store = transaction.objectStore('blobs');
          var blob = new Blob(['hello'], { type: 'text/plain' });
          var request = store.put(blob, 'blobKey');
          request.onsuccess = function () {
            resolve(true);
          };
          request.onerror = function (e) {
            resolve(false);
          };
        } catch (error) {
          resolve(false);
        }
      };

      openRequest.onerror = function () {
        resolve(false);
      };
    });
  }

  isDBAvailable() {
    return this.db !== null;
  }

  getAllBlobsFromIndexedDB() {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction(['recordings'], 'readonly');
      const store = transaction.objectStore('recordings');
      const request = store.getAll();

      request.onerror = (event) => {
        reject(event.target.errorCode);
      };

      request.onsuccess = (event) => {
        resolve(event.target.result);
      };
    });
  }
  concatenateBlobs(blobs, type) {
    return new Promise((resolve, reject) => {
      const concatenatedBlob = new Blob(blobs, { type: type });
      resolve(concatenatedBlob);
    });
  }

  saveBlobChunkToIndexedDB(blob) {
    if (!this.db) return;
    const transaction = this.db.transaction(['recordings'], 'readwrite');
    const store = transaction.objectStore('recordings');
    let request = store.add(blob);

    request.onerror = (event) => {
      console.error('Error writing to the database', event.target.errorCode);
    };
  }

  saveSettingsToIndexedDB(settings) {
    if (!this.db) return;
    const transaction = this.db.transaction(['settings'], 'readwrite');
    const store = transaction.objectStore('settings');
    let request = store.add(settings, 'recordingSettings');

    request.onerror = (event) => {
      console.error('Error writing to the database', event.target.errorCode);
    };
  }
  getSettingsFromIndexedDB() {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction(['settings'], 'readonly');
      const store = transaction.objectStore('settings');
      const request = store.get('recordingSettings');

      request.onerror = (event) => {
        reject(event.target.errorCode);
      };

      request.onsuccess = (event) => {
        resolve(event.target.result);
      };
    });
  }
  async clearObjectStore() {
    await this._clearObjectStore('recordingsDB', 'recordings');
    await this._clearObjectStore('recordingsDB', 'settings');
  }
  _clearObjectStore(dbName, storeName) {
    // Open a connection to the database
    const request = indexedDB.open(dbName);

    return new Promise((resolve, reject) => {
      request.onerror = (event) => {
        // Handle errors when opening the database
        console.error('Database error:', event.target.error);
        reject(event.target.error);
      };

      request.onsuccess = (event) => {
        const db = event.target.result;

        // Create a transaction with readwrite permissions
        const transaction = db.transaction(storeName, 'readwrite');

        transaction.onerror = (event) => {
          // Handle transaction errors
          console.error('Transaction error:', event.target.error);
          reject(event.target.error);
        };

        // Clear the object store
        const objectStore = transaction.objectStore(storeName);
        const clearRequest = objectStore.clear();

        clearRequest.onerror = (event) => {
          // Handle errors in the clear operation
          console.error('Clear operation error:', event.target.error);
          reject(event.target.error);
        };

        clearRequest.onsuccess = () => {
          // Return success
          resolve();
        };
      };
    });
  }
}

module.exports = {
  RecordingsDB,
};
